module.exports = __webpack_public_path__ + "img/edit.04e538c9.svg";